// OrderItem.js
import React from "react";

// MUI components
import { Typography } from "@material-ui/core";

// MUI icons
import {  Schedule } from "@material-ui/icons";

// // Local components
import { OrderSection } from "./OrderSection";

// Styled components / styles
import {

	EmptyState,
} from "../styles";


export const FreePortOrders = ({ orders, translate }) => {
	if (orders.length === 0) {
		return (
			<EmptyState>
				<Schedule style={{ fontSize: 20, marginBottom: 6, color: "#9ca3af" }} />
				<Typography style={{ fontSize: "12px", color: "#6b7280" }}>{translate("resources.dashboard_ports.port.no_upcoming_orders")}</Typography>
			</EmptyState>
		);
	}

	return <OrderSection title={translate("resources.dashboard_ports.port.upcoming_orders")} orders={orders} />;
};
